import { createSlice } from '@reduxjs/toolkit';

import type { ClientInfo } from '../../types';

import { getProfileThunk } from 'app/modules/Personal/actions/profile';
import { logout } from 'app/redux/actions/auth';

import { getClientInfo } from '../../actions';

export const initialState: ClientInfo = {
  data: null,
  clientInfoLoading: false,
  clientInfoRequested: false,
  clientInfoSettingsLoading: false,
  clientInfoSettingsRequested: false,
};

export const clientInfoSlice = createSlice({
  name: 'client-info',
  initialState,
  reducers: {
    getClientInfoSuccess: (state, action) => {
      state.clientInfoLoading = false;
      state.clientInfoRequested = true;

      state.data = action.payload;
    },
    addPersonalData: (state, action) => {
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
    updateBalance: (state, action) => {
      if (state.data) {
        state.data.balance = action.payload.balance;
        state.data.withdrawalBalance = action.payload.withdrawalBalance;
      }
    },
    updateCashbackExperience: (state, action) => {
      if (state.data === null) {
        return;
      }

      if (state.data.cashback) {
        state.data.cashback = { ...action.payload };
      }
    },
    setEmail: (state, action) => {
      if (state.data === null) {
        return;
      }

      state.data.email = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClientInfo.pending, (state) => {
        state.clientInfoLoading = true;
        state.clientInfoRequested = false;
      })
      .addCase(getClientInfo.fulfilled, (state, action) => {
        state.clientInfoLoading = false;
        state.clientInfoRequested = true;

        const { data } = action.payload;

        state.data = data;
      })
      .addCase(getClientInfo.rejected, (state) => {
        state.clientInfoLoading = false;
        state.clientInfoRequested = true;
      })
      .addCase(getProfileThunk.pending, (state) => {
        state.clientInfoSettingsLoading = true;
        state.clientInfoSettingsRequested = false;
      })
      .addCase(getProfileThunk.fulfilled, (state, action) => {
        state.clientInfoSettingsLoading = false;
        state.clientInfoSettingsRequested = true;

        const { data } = action.payload;

        state.data = {
          ...state.data,
          agreementToEmailing: data.agreementToEmailing,
          birthday: data.birthday,
        };
      })
      .addCase(getProfileThunk.rejected, (state) => {
        state.clientInfoSettingsLoading = false;
        state.clientInfoSettingsRequested = true;
      });
    builder
      .addMatcher((action) => action.type === logout.fulfilled.toString(), () => initialState);
  },
});

export const { reducer: clientInfoReducer, actions: clientInfoActions } = clientInfoSlice;

export const {
  getClientInfoSuccess,
  addPersonalData,
  updateBalance,
  updateCashbackExperience,
  setEmail,
} = clientInfoActions;
